const checkboxGroupKey = Symbol("ArcoCheckboxGroup");
export { checkboxGroupKey };
